import axios, { AxiosResponse } from 'axios';
import Customer from '../models/data/Customer';
import CustomerEquipment from '../models/data/CustomerEquipment';
import SearchEquipmentsRequest from '../models/requests/SearchEquipmentsRequest';
import SearchCustomersRequest from '../models/requests/SearchCustomersRequest';
import { createRequestConfig } from './utils';

/**
 * 最終需要家一覧を取得する
 * @param url basenameを考慮したURL
 * ```typescript
 * const history = useHistory();
 * const url = history.createHref({ pathname: pathnames.customers });
 * ```
 * @param params 顧客情報検索条件
 * @returns 最終需要家の配列
 */
export function requestCustomers(
  url: string,
  params?: SearchCustomersRequest,
): Promise<AxiosResponse<Customer[]>> {
  const config = createRequestConfig({ params });
  return axios.get<Customer[]>(url, config);
}

/**
 * 顧客設備一覧を取得する
 * @param url basenameを考慮したURL
 * ```typescript
 * const history = useHistory();
 * const url = history.createHref({ pathname: pathnames.equipments });
 * ```
 * @param params 顧客設備検索条件
 * @returns 顧客設備の配列
 */
export function requestEquipments(
  url: string,
  params?: SearchEquipmentsRequest,
): Promise<AxiosResponse<CustomerEquipment[]>> {
  const config = createRequestConfig({ params });
  return axios.get<CustomerEquipment[]>(url, config);
}
